<template>
  <modal
    :name="modalName"
    resizable
    draggable=".window-header"
    width="500"
    height="auto"
    :scrollable="true"
  >
    <i-bar title="가상 입금" class="window-header">
      <i-bar-btn @click="saveItem">저장</i-bar-btn>
      <i-bar-btn @click="doClose">닫기</i-bar-btn>
    </i-bar>

    <table class="tbl01">
      <colgroup><col width="100px"/><col/></colgroup>
        <tr>
          <th>입금자명</th>
          <td>{{sitem.membnm}}</td>
        </tr>
        <tr>
          <th>가상계좌번호</th>
          <td>{{sitem.vraccno}}</td>
        </tr>
        <tr>
          <th>금액</th>
          <td>{{sitem.totsum | comma }}원</td>
        </tr>
        <tr>
          <th>입금액</th>
          <td><i-input v-model="sitem.amt" right  @keyup.enter="saveItem" />원</td>
        </tr>
    </table>
  </modal>
</template>

<script>

let ui
const isDebug = false
export default {
  data () {
    return {
      modalName: "c가상입금_" + T.randomAZ(10),
      sitem : {},
    }
  },
  created() {
    ui = this.$ui;
  },
  methods : {
    open(sitem) {
      this.sitem = {
        ...sitem,
        amt : sitem.totsum
      }
      this.$modal.show(this.modalName);
    },
    doClose () {
      this.$modal.hide(this.modalName);
    },
    saveItem() {

      if(!this.sitem.amt){
        ui.alert("입금액을 입력해 주세요.")
        return
      }

      // ui.confirm('저장하시겠습니까 ?', "저장확인")
      //   .then(r => r && this.itemUpdate())

      this.itemUpdate()
    },
    itemUpdate() {

      ui.httpGet('/proc/N_VRTRADE_INS_TEST',
      {
        iv_vraccno : this.sitem.vraccno,
        iv_amt : this.sitem.amt,
        iv_custname : this.sitem.membnm,
      }, ret => {
        const { msg, status } = ret.data.rs1[0]
        if (status == '0') { // 작업이 정상 완료일때
          ui.notify(msg)
          this.doClose()
          this.$emit("save")
        } else {
          ui.notify(msg)
          this.doClose()
          this.$emit("save")
      }
      })
    },
  }
}
</script>